import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCoordinatedOverlay } from '#pplx/frontend/aether/components/AetherProvider/useAetherContext.js';
import { Popover } from '#pplx/frontend/aether/components/Popover/index.js';
import { TextPrimitive } from '#pplx/frontend/aether/primitives/TextPrimitive/index.js';
import { UpsellTierBadge } from '#pplx/frontend/apps/ask/ask-input/ask-input-upsell-popover/components/UpsellTierBadge.js';
import { noop } from 'lodash-es';
import React, { useCallback, useMemo, useRef } from 'react';
const DEFAULT_MAX_WIDTH_PX = 250;
const CLOSE_DELAY_MS = 0;
const AskInputInteractiveHoverPopover = React.memo(function AskInputInteractiveHoverPopover({ children, triggerElement, maxWidthPx = DEFAULT_MAX_WIDTH_PX, }) {
    // Radix HoverCard loses track of pointer events when menu items are the trigger,
    // so we manually control the open state via onMouseEnter/onMouseLeave.
    const { isOpen, open, close } = useCoordinatedOverlay();
    const timerRef = useRef(null);
    const handleMouseEnter = useCallback(() => {
        if (timerRef.current)
            clearTimeout(timerRef.current);
        open();
    }, [open]);
    const handleMouseLeave = useCallback(() => {
        if (timerRef.current)
            clearTimeout(timerRef.current);
        timerRef.current = setTimeout(() => {
            close();
        }, CLOSE_DELAY_MS);
    }, [close]);
    const controlledTrigger = useMemo(() => (_jsx("div", { onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, children: triggerElement })), [handleMouseEnter, handleMouseLeave, triggerElement]);
    return (_jsx(Popover, { interaction: "hover", side: "right", align: "start", appearance: "light", maxWidthPx: maxWidthPx, triggerElement: controlledTrigger, open: isOpen, onOpenChange: noop, onContentMouseEnter: handleMouseEnter, onContentMouseLeave: handleMouseLeave, children: children }));
});
export const AskInputUpsellPopover = React.memo(function AskInputUpsellPopover({ title, description, children, maxWidthPx = DEFAULT_MAX_WIDTH_PX, disabled, requiredTier, }) {
    if (disabled) {
        return children;
    }
    return (_jsx(AskInputInteractiveHoverPopover, { triggerElement: children, maxWidthPx: maxWidthPx, children: _jsxs("div", { className: "flex flex-col gap-2 p-1", children: [_jsxs("div", { className: "flex items-center gap-2", children: [_jsx(UpsellTierBadge, { requiredTier: requiredTier }), _jsx(TextPrimitive, { size: "sm", weight: "semibold", children: title })] }), _jsx(TextPrimitive, { size: "sm", color: "light", children: description })] }) }));
});
//# sourceMappingURL=AskInputUpsellPopover.js.map